import React from 'react';
import { Text } from 'react-native-paper';
import { StyleSheet } from 'react-native';
import { COLORS } from '../../constants';

/**
 * Heading Component
 * 
 * This component renders a customizable text header using the `Text` component from 'react-native-paper'.
 * It supports customizing the font size, color, and accepts additional props to provide greater flexibility.
 * Default values for text and color ensure robustness.
 *
 * Props:
 *  - text: The text content for the heading. Defaults to 'Heading' if not provided.
 *  - fontSize: The font size for the text. Must be provided for proper styling.
 *  - color: Optional color for the text, defaulting to COLORS.textDarker.
 *  - style: Additional style props that are passed directly to the Text component, allowing for more customization.
 *
 * This component is particularly useful for titles and headers in various parts of an application,
 * ensuring consistency in typography and style while being highly customizable.
 */
const Heading = ({ text = 'Heading', fontSize, color = COLORS.textDarker, style }) => {
    return (
        <Text style={[styles.header, { fontSize, color, lineHeight: fontSize * 1.5 }, style]}>
            {text}
        </Text>
    );
};

const styles = StyleSheet.create({
    header: {
        textAlign: 'left',
        fontWeight: 'bold',
    },
});

export default Heading;
